export enum DateFormat {
  Auto = 'auto',
  Date = 'YYYY-MM-DD',
  Long = 'YYYY-MM-DD HH:mm',
  Full = 'YYYY-MM-DD HH:mm:ss',
  Short = 'HH:mm',
}
